import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import API_BASE from "../config/api";

export default function CommentsReviews() {
    const [params] = useSearchParams();
    const listinguid = params.get("listinguid");

    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!listinguid) return;

        fetch(`${API_BASE}/api/get_comments.php?listinguid=${listinguid}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) setReviews(data.comments);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [listinguid]);

    return (
        <div className="container py-4">

            {/* HEADER */}
            <div
                className="rounded p-3 mb-4 shadow-sm"
                style={{
                    background: "linear-gradient(135deg, #e8f0ff, #fefefe)",
                    borderLeft: "6px solid #4a90e2"
                }}
            >
                <h4 className="fw-bold text-dark mb-1">
                    <i className="bi bi-chat-dots-fill me-2 text-primary"></i>
                    Comments & Reviews
                </h4>
                <p className="text-secondary mb-0">
                    Feedback for this listing.
                </p>
            </div>

            {/* LOADING */}
            {loading && (
                <div className="text-center py-5 text-secondary">Loading reviews...</div>
            )}

            {/* EMPTY */}
            {!loading && reviews.length === 0 && (
                <div className="text-center py-5">
                    <i className="bi bi-chat-left-text text-primary" style={{ fontSize: "3.5rem" }}></i>
                    <h5 className="fw-semibold text-secondary mt-3 mb-1">No Reviews Yet</h5>
                    <p className="text-muted">Feedback for this listing will appear here.</p>
                </div>
            )}

            {/* REVIEWS GRID */}
            <div className="row g-3">
                {reviews.map((item) => (
                    <div key={item.id} className="col-md-6 col-sm-12">
                        <div className="card shadow-sm border-0 rounded-4 hover-card">
                            <div className="card-body p-3">

                                {/* Listing Title */}
                                <h6 className="fw-bold text-primary mb-1">{item.listing_title}</h6>

                                {/* Commenter and Date */}
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <small className="text-muted">{item.commenter_name}</small>
                                    <small className="text-muted">{item.date}</small>
                                </div>

                                {/* Comment */}
                                <p className="text-secondary mb-2">{item.comment}</p>

                                {/* Star Rating */}
                                <div className="mb-2">
                                    {[...Array(item.star)].map((_, i) => (
                                        <i key={i} className="bi bi-star-fill text-warning me-1"></i>
                                    ))}
                                    {[...Array(5 - item.star)].map((_, i) => (
                                        <i key={i} className="bi bi-star text-warning me-1"></i>
                                    ))}
                                </div>

                                {/* Likes / Dislikes / Loves Badges */}
                                <div className="d-flex gap-2">
                                    <span className="badge bg-success">
                                        <i className="bi bi-hand-thumbs-up-fill me-1"></i>{item.likes}
                                    </span>
                                    <span className="badge bg-danger">
                                        <i className="bi bi-hand-thumbs-down-fill me-1"></i>{item.dislikes}
                                    </span>
                                    <span className="badge" style={{ backgroundColor: "#ff5a5f", color: "#fff" }}>
                                        <i className="bi bi-heart-fill me-1"></i>{item.loves}
                                    </span>
                                </div>

                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* STYLES */}
            <style>{`
                .hover-card:hover {
                    transform: translateY(-2px);
                    transition: 0.2s;
                    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
                }
            `}</style>
        </div>
    );
}
